import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ReferringPageProvider from '../ReferringPageProvider';
/**
 * A utility component that will wait until after mounting to render its
 * children.
 */

function AfterMount(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  useEffect(function () {
    setMounted(true);
  }, []);
  return mounted ? children : null;
}

AfterMount.propTypes = {
  children: PropTypes.node
};
export default function MarketingSnippets(_ref2) {
  var children = _ref2.children,
      referringPageCookieName = _ref2.referringPageCookieName,
      requestInfo = _ref2.requestInfo,
      snippets = _ref2.snippets;
  var pageWillUnmount = useSelector(function (state) {
    return state.app.pageWillUnmount;
  });
  var afterContent = snippets.afterContent,
      afterMount = snippets.afterMount,
      beforeContent = snippets.beforeContent,
      head = snippets.head;

  if (typeof afterContent === 'function') {
    afterContent = afterContent(requestInfo);
  }

  if (typeof afterMount === 'function') {
    afterMount = afterMount(requestInfo);
  }

  if (typeof beforeContent === 'function') {
    beforeContent = beforeContent(requestInfo);
  }

  if (typeof head === 'function') {
    head = head(requestInfo);
  }

  var content = referringPageCookieName ? /*#__PURE__*/React.createElement(ReferringPageProvider, {
    cookieName: referringPageCookieName
  }, children) : children;
  return pageWillUnmount ? content : /*#__PURE__*/React.createElement(React.Fragment, null, head ? /*#__PURE__*/React.createElement(Head, null, head) : null, beforeContent, content, afterContent, afterMount ? /*#__PURE__*/React.createElement(AfterMount, null, afterMount) : null);
}
MarketingSnippets.propTypes = {
  children: PropTypes.node,
  referringPageCookieName: PropTypes.string,
  requestInfo: PropTypes.object,
  snippets: PropTypes.object
};